import React from 'react'
import myImage from "../../assets/panda.png"

function MyAvatar() {
  return (
    <div style={{height: "40px", width: "40px", margin:"0px", padding: "0px"}}>
      <img style={{height: "30px", width: "30px"}} src={myImage} />
    </div>
  )
}

export default MyAvatar
